import React from 'react';

interface ButtonProps {
  text: string;
}

const Button: React.FC<ButtonProps> = ({ text }) => {
  return (
    <button className="px-4 py-1 font-sfui bg-yellow-300 text-black rounded hover:bg-opacity-80 round-[16px]">
      {text}
    </button>
  );
};

export default Button;
